import { render, staticRenderFns } from "./ClientVisits.vue?vue&type=template&id=4a54a867"
import script from "./ClientVisits.vue?vue&type=script&lang=js"
export * from "./ClientVisits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports